module.exports = __webpack_public_path__ + "static/media/spinner.4586aa83.gif";